// $(document).ready(function () {
//   $("#rondellCarousel").addClass("card");
// });

// $(document).ready(function () {
//   $(".jdgm-write-review-modal__close-btn").on("click", function () {
//     location.reload(); // Page refresh
//   });
// });

// for non-blocking rendering css
// document.addEventListener("DOMContentLoaded", function() {
//   let sqaCSS = document.querySelector('link[href*="sqa-extension.css"]');
//   if (sqaCSS) {
//     sqaCSS.setAttribute("media", "print");
//     sqaCSS.onload = function() {
//       this.media = "all";
//     };
//   }
// });

$(document).on("click", ".jdgm-write-review-modal__close-btn", function () {
  location.reload();
});


// Cart page countdown

// document.addEventListener("DOMContentLoaded", function () {
//     // Timer duration (seconds me)
//     let holdTime = 15 * 60; // 15 minutes
//     const timerEl = document.getElementById("cart-timer");

//     function clearCart() {
//       fetch("/cart/clear.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Accept": "application/json"
//         }
//       })
//         .then(() => {
//           document.getElementById("cart-hold-message").innerText =
//             "Your cart hold has expired. Cart is now empty.";
//           // optional: cart page refresh
//           location.reload();
//         })
//         .catch((err) => console.error("Cart clear failed:", err));
//     }

//     function updateTimer() {
//       if (holdTime <= 0) {
//         timerEl.innerText = "00:00";
//         clearCart();
//         return;
//       }

//       const minutes = String(Math.floor(holdTime / 60)).padStart(2, "0");
//       const seconds = String(holdTime % 60).padStart(2, "0");

//       timerEl.innerText = `${minutes}:${seconds}`;
//       holdTime--;

//       setTimeout(updateTimer, 1000);
//     }

//     updateTimer();
//   });

// Cart timer restart on every refresh

  // document.addEventListener("DOMContentLoaded", function () {
  //   // Timer duration (seconds me)
  //   let holdTime = 15 * 60; // 15 minutes
  //   const timerEl = document.getElementById("cart-timer");

  //   if (timerEl){
  //   function updateTimer() {
  //     if (holdTime <= 0) {
  //       timerEl.innerText = "00:00";
  //       document.getElementById("cart-hold-message").innerText =
  //         "Your cart hold has expired.";
  //       return;
  //     }

  //     const minutes = String(Math.floor(holdTime / 60)).padStart(2, "0");
  //     const seconds = String(holdTime % 60).padStart(2, "0");

  //     timerEl.innerText = `${minutes}:${seconds}`;
  //     holdTime--;

  //     setTimeout(updateTimer, 1000);
  //   }
  // }
  //   updateTimer();
  // });

//Products tabs code

// document.addEventListener("DOMContentLoaded", function(){
//   let container = document.getElementById("product-tabs-content");
//   if(!container) return;
//   let html = container.innerHTML;

//   // Split by <h3>
//   let sections = html.split(/<h3>/i);

//   if(sections.length > 1){
//     let tabButtons = "";
//     let tabContents = "";

//     sections.forEach((sec, index)=>{
//       if(index === 0){
//         if(sec.trim() !== "") {
//           tabButtons += `<li data-tab="tab${index}" class="active">Description</li>`;
//           tabContents += `<div class="tab-content active" id="tab${index}">${sec}</div>`;
//         }
//       } else {
//         let parts = sec.split(/<\/h3>/i);
//         let title = parts[0].trim();
//         let content = parts[1] ? parts[1].trim() : "";

//         tabButtons += `<li data-tab="tab${index}">${title}</li>`;
//         tabContents += `<div class="tab-content" id="tab${index}">${content}</div>`;
//       }
//     });

//     // Inject tab structure inside wrapper
//     container.innerHTML = `
//       <div class="tabs-wrapper">
//         <ul class="tab-buttons">${tabButtons}</ul>
//         <div class="tab-contents">${tabContents}</div>
//       </div>
//     `;

//     // Tab switching
//     container.querySelectorAll(".tab-buttons li").forEach(btn=>{
//       btn.addEventListener("click", function(){
//         container.querySelectorAll(".tab-buttons li").forEach(b=>b.classList.remove("active"));
//         container.querySelectorAll(".tab-content").forEach(c=>c.classList.remove("active"));
//         this.classList.add("active");
//         container.querySelector("#"+this.dataset.tab).classList.add("active");
//       });
//     });
//   }
// });

// Info icon js

document.addEventListener("DOMContentLoaded", function () {
  // 1. Open modal when clicking info icon
  document.querySelectorAll(".product-info-text").forEach(function (textEl) {
    textEl.addEventListener("click", function () {
      let modalTarget = textEl.getAttribute("data-modal-target");
      if (modalTarget) {
        let modal = document.querySelector(modalTarget);
        if (modal) {
          modal.style.display = "block";
          document.documentElement.style.overflow = "hidden";
        }
      }
    });
  });

  // 2. Close modal when clicking close button
  document.querySelectorAll(".info-modal-close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      let modal = btn.closest(".info-modal");
      if (modal) {
        modal.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    });
  });

  // 3. Close modal when clicking on backdrop
  document.querySelectorAll(".info-modal").forEach(function (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    });
  });
});

// Size guide js

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("size-guide-btn");
  const modal = document.getElementById("size-guide-modal");
  const closeBtn = document.querySelector(".modal-close");

  if (btn && modal) {
    btn.addEventListener("click", () => {
      modal.style.display = "flex";
      document.documentElement.style.overflow = "hidden"; // prevent scroll
    });

    // 2. Close modal when clicking close button
  document.querySelectorAll(".modal-close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      let modal = btn.closest(".size-guide-modal");
      if (modal) {
        modal.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    });
  });

  // 3. Close modal when clicking on backdrop
  document.querySelectorAll(".size-guide-modal").forEach(function (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    });
  });
  }
});
